import FormElement from "../../forms/form_element";
import { RadioInputField } from "../../lib/radio-input/radio-input";
import { Field, change } from "redux-form";
import { connect } from "react-redux";
import React, { useState } from "react";
import {
  campaignEditorFormName,
  CampaignEditorPageFormsWrapper,
  redemptionCodeValueToDisplay,
} from "./campaign_editor_helpers";
import ExternalLink from "../../lib/external_link";
import { ProductExchangeHelpDocURL } from "../../../constants/campaigns";
import Checkbox from "../../forms/checkbox";
import { If } from "react-extras";
import isEmpty from "lodash/isEmpty";

const ProductSamples = props => {
  const { handleSubmit, validationErrors, initialValues, clearField } = props;
  const [hasMultiRedemptionCodes, setHasMultiRedemptionCodes] = useState(
    !isEmpty(initialValues?.redemptionCodeStringForm)
  );

  return (
    <form onSubmit={handleSubmit}>
      <>
        <Field
          onChange={value => {
            // if the user selects a different option, clear out redemption codes
            // so we don't save to campaign
            if (value !== "instructions") {
              clearField("redemptionCodeStringForm");
            }
          }}
          component={FormElement}
          name="productExchangeType"
          label="Will the podcasters receive free product samples for this campaign?*"
          componentClass={RadioInputField}
          validationErrors={validationErrors}
          defaultValue="none"
          options={[
            {
              value: "none",
              display: redemptionCodeValueToDisplay.none,
            },
            {
              value: "mailing",
              display: redemptionCodeValueToDisplay.mailing,
              infoText:
                "You’ll be able to download a list</br>of mailing addresses from your</br>Campaign Dashboard when </br>hosts accept your campaign",
              infoDirection: "right",
            },
            {
              value: "instructions",
              display: redemptionCodeValueToDisplay.instructions,
              optionalFields: () => (
                <div className={"m-ls"}>
                  <Field
                    component={FormElement}
                    rows={5}
                    name={"productExchangeInstructions"}
                    componentClass="textarea"
                    placeholder={
                      "e.g. Go to https://nike.com and add the Nike Air Max to your cart. \n" +
                      "(If you have one code): Enter the redemption code NIKE10 at checkout to receive this item for free."
                    }
                    type="textarea"
                    label="instructions for podcasters to redeem product online*"
                    validationErrors={validationErrors}
                    helpText={
                      <div className={"small m-bxxs"}>
                        All Podcasters will see exactly what is in this box. If you have one
                        standard code that *all* podcasts can use (eg NIKE10) to checkout on your
                        website, enter it above. If you have a list of *unique* codes (one per
                        podcast host), use the section below to paste the list of unique codes.
                      </div>
                    }
                  />
                  <Checkbox
                    onClick={() => {
                      setHasMultiRedemptionCodes(!hasMultiRedemptionCodes);
                      if (hasMultiRedemptionCodes) clearField("redemptionCodeStringForm");
                    }}
                    defaultChecked={hasMultiRedemptionCodes}
                    checkboxLabel="Brand will provide multiple redemption codes (one per podcast host) "
                  />
                  <If condition={hasMultiRedemptionCodes}>
                    <Field
                      rows={5}
                      component={FormElement}
                      name={"redemptionCodeStringForm"}
                      componentClass="textarea"
                      className={"m-b0"}
                      type="textarea"
                      label="paste a LIST OF UNIQUE Redemption codes (codes only)"
                      placeholder={"NIKEabc,\nNIKEdef,\nNIKExyz"}
                      validationErrors={validationErrors}
                      helpText={
                        <div className={"small m-bxxs"}>
                          When podcasts accept your campaign offer, we will provide each host with a
                          unique code from this list. We suggest that you add more codes than you
                          think you’ll need. We will let you know which codes we match to which
                          shows.
                        </div>
                      }
                    />
                  </If>
                </div>
              ),
            },
          ]}
        />
        <ExternalLink className={"bold"} href={ProductExchangeHelpDocURL}>
          Learn more about sharing product &rarr;
        </ExternalLink>
      </>
    </form>
  );
};

const mapDispatchToProps = {
  clearField: field => change(campaignEditorFormName, field, ""),
};

export default CampaignEditorPageFormsWrapper(
  connect(() => ({}), mapDispatchToProps)(ProductSamples)
);
